import { Button, Flex, Modal } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { useCategoriesStore } from '@/shared/stores/categories.store';

import { useDeleteCategoryMutation } from '../model/delete-category-modal.cases';

export function DeleteCategoryModal() {
  const deletableCategory = useCategoriesStore(
    (state) => state.deletableCategory,
  );
  const setDeletableCategory = useCategoriesStore(
    (state) => state.setDeletableCategory,
  );
  const deleteCategoryMutation = useDeleteCategoryMutation();

  return (
    <Modal
      opened={!!deletableCategory}
      onClose={() => setDeletableCategory(null)}
      title="Удаление категории"
    >
      {deletableCategory && (
        <>
          <p>
            Вы действительно хотите удалить категорию{' '}
            <b>{deletableCategory.title}</b>?
          </p>
          <Flex justify="space-between" gap={16} mt={20}>
            <Button
              variant="light"
              fullWidth
              onClick={() => setDeletableCategory(null)}
            >
              Отмена
            </Button>
            <Button
              fullWidth
              color="red"
              loading={deleteCategoryMutation.isPending}
              onClick={() => {
                void deleteCategoryMutation
                  .mutateAsync(deletableCategory.id)
                  .then((result) => {
                    setDeletableCategory(null);

                    notifications.show({
                      message: 'Категория удалена',
                      color: 'green',
                    });
                    return result;
                  });
              }}
            >
              Удалить
            </Button>
          </Flex>
        </>
      )}
    </Modal>
  );
}
